<template>
  <div class="form-group col-lg-12">
    <div class="form-group col-lg-12">
      <label for="client">{{ $t("client") }}</label>
      <Combobox
        class="bg-white"
        name="client"
        :placeholder="$t('select_a_item')"
        :hasErrors="errors.has('client')"
        :options="clients"
        :initial-value="installInstruction.client"
        :getOptionLabel="(client) => `${client.CLI_ID} - ${client.CLI_DSC}`"
        v-model="installInstruction.client"
        :reduce="(client) => client.CLI_ID"
        v-validate="'required'"
        :disabled="Boolean(installInstruction.id)"
      />

      <small v-show="errors.has('client')" class="form-text text-muted">
        {{ errors.first("client") }}
      </small>
    </div>

    <TextEditor v-model="installInstruction.html" />

    <div class="form-group mt-2" style="justify-items: end">
      <LoaderButton @click="save">
        {{ $t("save") }}
      </LoaderButton>
    </div>
  </div>
</template>

<script>
import LoaderButton from "@/components/button/LoaderButton";
import Combobox from "@/components/shared/ComboBox";
import TextEditor from "@/components/shared/TextEditor";
import { mapActions, mapState } from "vuex";

export default {
  name: "IntegratorInstallInstructionsFormComponent",
  components: {
    LoaderButton,
    Combobox,
    TextEditor,
  },

  props: {
    installInstruction: {
      type: Object,
      default: () => ({
        id: undefined,
        client: undefined,
        html: "",
      }),
    },
  },

  computed: {
    ...mapState({
      clients: (state) => state.arena.clients,
    }),
  },

  methods: {
    ...mapActions("integrator", [
      "addIntegratorInstallInstructions",
      "editIntegratorInstallInstructions",
      "cleanState",
    ]),

    async save() {
      const { dispatch } = this.$store;

      const valid = await this.$validator.validateAll();
      if (!valid) {
        const err = new Error(this.$t("invalid_form_fields"));
        dispatch("notify/error", err);
        return;
      }

      const { id, ...rest } = this.installInstruction;

      const createdOrUpdated = id
        ? await this.editIntegratorInstallInstructions({ id, data: rest })
        : await this.addIntegratorInstallInstructions(rest);

      createdOrUpdated &&
        this.$router.push({ name: "listintegratorinstallinstructions" });
    },
  },

  mounted() {
    this.$store.dispatch("arena/fetchClients");
  },

  destroyed() {
    this.cleanState();
  },
};
</script>
